import { setCookie } from '@/http/sharedStorage';
const userKey = 'user';
const state = {
    user: localStorage.getItem(userKey)
        ? JSON.parse(localStorage.getItem(userKey) ?? '')
        : null,
    defaultAddress: null,
};
const mutations = {
    setUser(state, user) {
        state.user = user;
        localStorage.setItem(userKey, JSON.stringify(user));
        // Whatever you were putting in localStorage:
        const payload = JSON.stringify({
            user: user,
        });
        setCookie("shared_state_user", payload, {
            domain: process.env.VUE_APP_LOGIN_HOST.replace("login", "").replace("pre-prod-", ""),
            days: 1,
            secure: true,
            sameSite: "Lax",
            path: "/",
        });
    },
    resetUser(state, user) {
        state.user = null;
        localStorage.removeItem(userKey);
    },
    setDefaultAddress(state, address) {
        state.defaultAddress = address;
    },
};
const getters = {
    userName: (state) => {
        return state.user?.name;
    },
};
export const userModule = {
    state,
    mutations,
    getters,
    namespaced: true,
};
